import { useContext, useState } from "react";
import Box from "../../../components/utility/box";
import CreateTaskHeader from "../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader";
import { AppContext } from "../../../context/ContextProvider";
import copyIcon from "@iso/assets/images/copyImg.svg";
import { copyText } from "../../../context/helper";
import { Tooltip } from "antd";

import eyeIcon from '@iso/assets/images/icon/eye-icon.svg';
import eyeCloseIcon from '@iso/assets/images/icon/eye-close-icon.svg';


let titleStyle = {
    margin: '10px 0',
    fontSize: '16px',
    fontFamily: 'Poppins',
    fontWeight: '600',
    color: "#1f1f1f",

}

let subTitleStyle = {
    margin: '10px 0',
    fontSize: '13px',
    color: "#a6a6a6",
    fontFamily: 'Nunito Sans',
    fontWeight: '600',
    wordWrap: "break-word",
}

// Amber helper note shown under the Endpoint for private imported clusters,
// where Atmosly can create the ingress but can't manage DNS on the user's behalf.
// A block <span> (not <div>) so it stays valid markup inside the <p> BoxSubTitle.
let endpointNoteStyle = {
    display: "block",
    marginTop: "10px",
    padding: "8px 12px",
    fontSize: '12px',
    fontFamily: 'Nunito Sans',
    fontWeight: '600',
    color: "#ad6800",
    lineHeight: "18px",
    wordWrap: "break-word",
    background: "#fffbe6",
    border: "1px solid #ffe58f",
    borderRadius: "6px",
}

let boxStyle = {
    border: '0',
    padding: "0",
    width: "100%",
    //marginTop: "50px",
}

// A single label/value row in the right "More info" drawer. `first` adds the
// extra top padding the first row needs to clear the fixed drawer header.
const InfoRow = ({ title, children, first }) => (
    <div style={{ padding: first ? "110px 20px 0 20px" : "20px 20px 0 20px" }}>
        <Box
            title={title}
            subtitle={children}
            titleStyle={titleStyle}
            subTitleStyle={subTitleStyle}
            style={boxStyle}
        />
    </div>
);

// A resource breakdown rendered as aligned "label  Request x · Limit y" rows.
// Spans (not divs) so it stays valid markup inside the <p> BoxSubTitle.
const ResourceList = ({ rows }) => (
    <span style={{ display: "block" }}>
        {rows.map((r) => (
            <span key={r.label} style={{ display: "flex", gap: "12px", lineHeight: "24px" }}>
                <span style={{ minWidth: "84px", color: "#6b6b6b", fontWeight: 600 }}>{r.label}</span>
                <span style={{ color: "#1f1f1f", fontWeight: 600 }}>{r.value}</span>
            </span>
        ))}
    </span>
);

export default function AddonsOverview({ data }) {
    const [addonsData, setAddonsData] = useState(data);
    console.log("addon data from the cluster overview: ", addonsData)
    const { openRightDrawer, setOpenRightDrawer, checkTryWithoutLogin, overviewData } = useContext(AppContext);
    const [tooltipTxt, setTooltipTxt] = useState({
        // username: "",
        // password: ""
    });
    const [showMore, setShowMore] = useState({
        admin: true,
        readOnly: true
    });
    const [isSecret, setIsSecret] = useState({
        admin: true,
        readOnly: true,
        password: true
    });

    const hideString = (isSecret, str) => {
        return isSecret ? Array.apply(null, { length: str.length }).map((temp, idx) => "*") : str;
    }


    const copyFunc = async (e, text) => {
        let res = await copyText(text);
        console.log("Tooltip: ", e.target.name, res);
        setTooltipTxt({
            [e.target.name]: "Copied"
        });
        setTimeout(() => {
            setTooltipTxt({
                [e.target.name]: ""
            });
        }, 2000);
    }

    // grafana-stack config the backend echoes back under user_values (snake_case).
    const uv = addonsData.user_values || {};
    // Prometheus is always installed; Grafana / Loki / DNS / credentials are only
    // meaningful when grafana_enabled. The backend sends grafana_enabled as the
    // string "true"/"false" — treat anything but an explicit false as enabled.
    const grafanaEnabled = !(uv.grafana_enabled === false || uv.grafana_enabled === "false");
    const nodeSelector = uv.node_selector && typeof uv.node_selector === "object" ? uv.node_selector : {};
    const nodeSelectorStr = Object.entries(nodeSelector).map(([k, v]) => `${k}: ${v}`).join(", ");
    const configuredHost = uv.record_prefix && uv.hosted_zone ? `${uv.record_prefix}.${uv.hosted_zone}` : "";
    // For a private imported cluster Atmosly creates the ingress but can't reach a
    // public DNS provider on the user's behalf, so the DNS record must be mapped by
    // hand. "Private" mirrors the Cluster API Access logic in ClusterInfo: no public
    // endpoint access ⇒ private. Show the note only for imported + private clusters.
    const clusterData = overviewData?.data?.cluster_data || {};
    const isPrivateImportedCluster = clusterData.provisioner === "imported" && clusterData.cloud_account_id == null;
    // Render a resource as explicit "Request x · Limit y" (omitting whichever side is unset).
    const reqLimit = (req, lim) => [req && `Request ${req}`, lim && `Limit ${lim}`].filter(Boolean).join("  ·  ");
    const promRows = [
        { label: "CPU", value: reqLimit(uv.prometheus_cpu_request, uv.prometheus_cpu_limit) },
        { label: "Memory", value: reqLimit(uv.prometheus_memory_request, uv.prometheus_memory_limit) },
        { label: "Storage", value: uv.prometheus_storage_size || "" },
        { label: "Retention", value: uv.prometheus_retention || "" },
    ].filter((r) => r.value);
    const grafanaRows = [
        { label: "CPU", value: reqLimit(uv.grafana_cpu_request, uv.grafana_cpu_limit) },
        { label: "Memory", value: reqLimit(uv.grafana_memory_request, uv.grafana_memory_limit) },
    ].filter((r) => r.value);

    return (
        <div>
            <CreateTaskHeader
                data={addonsData}
                buttonContent={addonsData.name}
                // values={{editing: true}}
                onCancel={() => {
                    setOpenRightDrawer({
                        drawerType: false,
                        drawerProps: {
                            data: addonsData.name
                        },
                    });
                }}
            />
            {addonsData.name === "grafana-stack" ? <>
                {grafanaEnabled ? <>
                    <div style={{ padding: "110px 20px 0 20px" }}>
                        <Box title="Username"
                            subtitle={<div style={{ display: "flex" }}>
                                <p style={{ ...subTitleStyle, marginRight: "10px" }}>{uv.grafana_user ? uv.grafana_user : "-"}</p>
                            </div>}
                            titleStyle={titleStyle}
                            subTitleStyle={subTitleStyle}
                            style={boxStyle}
                        />
                    </div>
                    <div style={{ padding: "20px 20px 0 20px" }}>
                        <Box title="Password"
                            subtitle={uv.grafana_password ?
                                <div>
                                    <span style={{ ...subTitleStyle, marginRight: "6px" }}>{isSecret.password ? "********" : uv.grafana_password}</span>
                                    <img src={isSecret.password ? eyeIcon : eyeCloseIcon} style={{ cursor: "pointer" }} onClick={() => {
                                        setIsSecret({
                                            ...isSecret,
                                            password: !isSecret.password
                                        });
                                    }} />
                                    <Tooltip title={tooltipTxt.password} placement="bottomLeft" open={tooltipTxt.password && tooltipTxt.password !== ""}>
                                        <img name="password" src={copyIcon} style={{ cursor: "pointer", marginLeft: "6px" }} onClick={(e) => {
                                            copyFunc(e, uv.grafana_password);
                                        }} />
                                    </Tooltip>
                                </div>
                                : "-"
                            }
                            titleStyle={titleStyle}
                            subTitleStyle={subTitleStyle}
                            style={boxStyle}
                        />
                    </div>
                    <InfoRow title="Endpoint">
                        {uv.url
                            ? (checkTryWithoutLogin ? uv.url : <a href={'https://' + uv.url} target="_blank">{uv.url}</a>)
                            : addonsData.host
                                ? (checkTryWithoutLogin ? addonsData.host : <a href={'https://' + addonsData.host} target="_blank">{addonsData.host}</a>)
                                : configuredHost
                                    ? (checkTryWithoutLogin ? configuredHost : <a href={'https://' + configuredHost} target="_blank">{configuredHost}</a>)
                                    : "-"}
                        {isPrivateImportedCluster && (
                            <span style={endpointNoteStyle}>
                                An ingress will be created for this endpoint, but since this is a private cluster the DNS record must be mapped to it manually.
                            </span>
                        )}
                    </InfoRow>
                    <InfoRow title="Dashboard refresh interval">
                        {uv.dashboard_refresh_interval ? uv.dashboard_refresh_interval + " seconds" : "-"}
                    </InfoRow>
                    <InfoRow title="Loki">{uv.loki_enabled ? "Enabled" : "Disabled"}</InfoRow>
                </> : (
                    <InfoRow title="Mode" first>Prometheus-only collector (Grafana disabled)</InfoRow>
                )}

                <InfoRow title="Cloud Watch Collector">{uv.cloudwatch_enabled ? "Enabled" : "Disabled"}</InfoRow>
                <InfoRow title="Node selector">{nodeSelectorStr || "-"}</InfoRow>
                {promRows.length > 0 && <InfoRow title="Prometheus resources"><ResourceList rows={promRows} /></InfoRow>}
                {grafanaEnabled && grafanaRows.length > 0 && <InfoRow title="Grafana resources"><ResourceList rows={grafanaRows} /></InfoRow>}
                {uv.s3_object_expiration && <InfoRow title="Object Expiration">{uv.s3_object_expiration}</InfoRow>}
            </>
                :
                addonsData.name === "kubernetes-dashboard" ? <>
                    <div style={{ padding: "110px 20px 0 20px" }}>
                        <Box title="Hostname"
                            subtitle={addonsData.host ? <a href={'https://' + addonsData.host} target="_blank">{addonsData.host}</a> : "-"}
                            titleStyle={titleStyle}
                            subTitleStyle={subTitleStyle}
                            style={boxStyle}
                        />
                    </div>
                    <div style={{ padding: "20px 20px 0 20px" }}>
                        <Box title="Admin Token"
                            subtitle={addonsData.admin_token ?
                                <>
                                    <div>
                                        <span style={{ ...subTitleStyle, marginRight: "6px" }}>{!showMore.admin ? isSecret.admin ? "********" : addonsData.admin_token : isSecret.admin ? "********" : addonsData.admin_token.substring(0, 60) + "..."}</span>
                                        <img src={isSecret.admin ? eyeIcon : eyeCloseIcon} style={{ cursor: "pointer" }} onClick={() => {
                                            setIsSecret({
                                                ...isSecret,
                                                admin: !isSecret.admin
                                            });
                                            setShowMore({
                                                ...showMore,
                                                admin: !showMore.admin
                                            });
                                        }} />
                                        {/*!isSecret.admin &&*/ addonsData.admin_token && addonsData.admin_token !== "" && <Tooltip title={tooltipTxt.admin} placement="bottomLeft" open={tooltipTxt.admin && tooltipTxt.admin !== ""}>

                                            <img name="admin" src={copyIcon} style={{ cursor: "pointer", marginLeft: "10px" }} onClick={(e) => {
                                                copyFunc(e, addonsData.admin_token);
                                            }} />
                                        </Tooltip>}
                                    </div>
                                    {/* {!isSecret.admin && <a onClick={() => {
                                        setShowMore({
                                            ...showMore,
                                            admin: !showMore.admin
                                        });
                                    }}>{showMore.admin ? "See more" : "See less"}</a>} */}
                                </>
                                : "-"} titleStyle={titleStyle}
                            subTitleStyle={subTitleStyle}
                            style={boxStyle}
                        />
                    </div>

                </>
                    : addonsData.host ? <>
                        <div style={{ padding: "110px 20px 0 20px" }}>
                            <Box title="Host"
                                subtitle={addonsData.chart_info && Object.keys(addonsData.chart_info).length > 0 ?
                                    <div>
                                        <span>{addonsData.host}</span>
                                        <Tooltip title={tooltipTxt.host} placement="bottomLeft" open={tooltipTxt.host && tooltipTxt.host !== ""}>
                                            <img name="host" src={copyIcon} style={{ cursor: "pointer", marginLeft: "10px" }} onClick={(e) => {
                                                copyFunc(e, addonsData.host);
                                            }} />
                                        </Tooltip>
                                    </div>
                                : "-"}
                                // subtitle={addonsData.value ? <a href={'https://' + addonsData.value} target="_blank">{addonsData.value}</a> : "-"}
                                titleStyle={titleStyle}
                                subTitleStyle={subTitleStyle}
                                style={boxStyle}
                            />
                        </div>
                    </>
                        : <>
                            <div style={{ padding: "110px 20px 0 20px" }}>
                                <Box title="Domain"
                                    subtitle={addonsData.hosted_zone ? addonsData.hosted_zone : "-"}
                                    // subtitle={addonsData.value ? <a href={'https://' + addonsData.value} target="_blank">{addonsData.value}</a> : "-"}
                                    titleStyle={titleStyle}
                                    subTitleStyle={subTitleStyle}
                                    style={boxStyle}
                                />
                            </div>
                        </>}
        </div>
    );
}